/**
 * Custom icon registry.
 *
 * To add a new custom icon:
 * 1. Place the file in src/assets/icons/  (e.g. my-icon.svg, my-icon.png)
 * 2. Add an entry to the array below with the full file name.
 *
 * SVG icons are registered via NzIconService and can be used as:
 *   <i nz-icon nzType="custom:my-icon"></i>
 *
 * Image icons (png, jpg, gif, webp) are rendered as <img> tags.
 */

const SVG_EXTENSIONS = ['.svg'];

export interface CustomIconEntry {
  /** File name without extension, used as the icon identifier */
  name: string;
  /** Full file name with extension */
  file: string;
  /** Whether this is an SVG (registered via NzIconService) or an image (rendered via <img>) */
  isSvg: boolean;
}

const iconFiles: string[] = [
  'add.svg',
  'calendar.svg',
  'loudspeaker.svg',
  'save.svg',
];

export const customIconEntries: CustomIconEntry[] = iconFiles.map(file => {
  const dotIndex = file.lastIndexOf('.');
  const name = file.substring(0, dotIndex);
  const ext = file.substring(dotIndex).toLowerCase();
  return { name, file, isSvg: SVG_EXTENSIONS.includes(ext) };
});
